import React from 'react';
import { Link } from 'react-router-dom';
import YouTubeIcon from '@mui/icons-material/YouTube';
import x from "../assets/MIQX-02.svg"
import {
  Container,
  Box,
  Grid,
  Typography,
//  Link,
  IconButton,
  makeStyles,
  styled,
  MenuList,
  MenuItem,
  Stack,
  Divider,
  createTheme
} from '@mui/material';
import { TranslateText } from '../utils/googletranslator';
import { Twitter, LinkedIn, FacebookRounded,Instagram } from '@mui/icons-material';
import TelegramIcon from '@mui/icons-material/Telegram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import razorpay_img from "../assets/razorpay-icon.png"
const CustomLink = styled(Link)((theme) => ({
  color:"#000",
  textDecoration:"none",
  fontSize:"12px",
  fontFamily: "'Poppins',sans-serif",
  ":hover":{
    color:"rgb(39,162,253,1)",
    textDecoration:"none",
     
  }
}))

const CustomMenuItem = styled(MenuItem)((theme)=>({
  padding:0,
  ":hover":{
    backgroundColor:"transparent"
  }
}))


const useStyles = styled((theme) => ({
  paymentIcon: {
    width: '40px',
    height: '40px',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    border: '1px solid #e7e7e7',
    backgroundColor: '#fff',
    marginRight: theme.spacing(1),
  },
  paymentIcons: {
    display: 'flex',
    alignItems: 'center',
  },
  linkList: {
    color:"#777777",
    listStyleType: 'none',
    padding: 0,
    '& li': {
      marginBottom: theme.spacing(1),
    },
  },
  
}));




const Footer = ()=> {
  const authtoken = localStorage.getItem('authtoken');
  const styles = {
    footerWrapper: {
      backgroundColor: '#FFF',
      // padding: theme.spacing(4, 0),
    },
    heading: {
      color:"#222529",
      fontSize: "17.01px",
      fontWeight: 700,
      lineHeight: "1em",
      letterSpacing: "-0.05em",
      marginBottom: "18px",
    },
    headers:{
      color:"#000",
      fontSize: "20px",
      fontWeight: 600,
      lineHeight: "1em",
      // letterSpacing: "-0.05em",
      // marginBottom: "18px",
      fontFamily: "'Poppins',sans-serif",
    },
    paymentIcon: {
      display:"inline-flex",
      verticalAlign:"middle",
      width: '55px',
      height: '32px',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      border: '1px solid #e7e7e7',
      borderRadius:"4px",
      color:"#000",
      backgroundColor: '#fff',
      margin:"0 1px 5px"
    },
    paymentIcons: {
      display: 'flex',
      alignItems: 'center',
    },
  }
  
  return (
    <Box  sx={[styles.footerWrapper,{width:"100%",display:"flex",justifyContent:"center",flexDirection:"column",alignItems:"center",background:"#F9F9FC",zIndex:2}]}>
      <Box sx={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:{xs:"24px 16px" ,md:"30px 120px"}}}>
      <Box sx={{width:"100%", padding:{xs:0 ,sm:0,md:0,lg:0}}}>
        <Grid container  sx={{display:"flex",alignItems:"center",justifyContent:"space-between",placeContent:"space-between"}}>
          <Grid item xs={12} sm={12} md={10}  >
            <TranslateText  sx={[styles.headers,{lineHeight:"44px",fontSize:"20px", fontFamily: "'Poppins',sans-serif",}]}>
              RESOURCES
            </TranslateText>
            <Box  gap={{xs:"8px",md:"16px"}}  sx={{display:"flex",alignItems:"center",justifyContent:"flex-start",flexWrap:"nowrap",overflow:{xs:"scroll",md:"scroll"},"&::-webkit-scrollbar":{display:"none"}, scrollBehavior:"smooth",}}>
              {/* <Box  sx={{bgcolor:{xs:"black",md:"transparent"},padding:"4px 12px", height:"26px",borderRadius:"10px",flexShrink:0}}>
                  {/* <CustomLink to="https://help.mayiiq.com/" target="_blank" sx={{color:{xs:"white",md:"black"},display:"flex",alignItems:"center"}}> 
                  <TranslateText to="https://help.mayiiq.com/" target="_blank" component={Link} sx={{
  textDecoration:"none",
  fontSize:"12px",
  fontFamily: "'Poppins',sans-serif",
  color:{xs:"white",md:"black"},display:"flex",alignItems:"center",
  ":hover":{
    color:"rgb(39,162,253,1)",
    textDecoration:"none",
    cursor:"pointer",
    
     
  }}}>
                  Help and FAQs
                  </TranslateText>
                   
                  {/* </CustomLink> 
              </Box>

              <Divider  orientation='vertical' sx={{height:"10px",border:"1px solid #ddd",display:{xs:"none",md:"block"}}}/>
               */}
              <Box   sx={{bgcolor:{xs:"black",md:"transparent"},padding:{xs:"4px 12px",md:"4px 0px"}, height:"26px",borderRadius:"10px",flexShrink:0}}>
                {/* <CustomMenuItem> */}
                  {/* <CustomLink to="/terms-service" sx={{color:{xs:"white",md:"black"},display:"flex",alignItems:"center"}}> */}
                  <TranslateText to="/terms-service" component={Link} sx={{
  textDecoration:"none",
  fontSize:"12px",
  fontFamily: "'Poppins',sans-serif",
  color:{xs:"white",md:"black"},display:"flex",alignItems:"center",
  ":hover":{
    color:"rgb(39,162,253,1)",
    textDecoration:"none",
    cursor:"pointer",
    
     
  }}}>
     Terms of Service
  </TranslateText>
                   
                  {/* </CustomLink> */}
                {/* </CustomMenuItem> */}
              </Box>
              
              <Divider  orientation='vertical' sx={{height:"10px",border:"1px solid #ddd",display:{xs:"none",md:"block"}}}/>

              <Box   sx={{bgcolor:{xs:"black",md:"transparent"},padding:"4px 12px", height:"26px",borderRadius:"10px",flexShrink:0}}>
                {/* <CustomMenuItem> */}
                  {/* <CustomLink to="/privacy-policy" sx={{color:{xs:"white",md:"black"},display:"flex",alignItems:"center"}} > */}
                  <TranslateText to="/privacy-policy" component={Link} sx={{
  textDecoration:"none",
  fontSize:"12px",
  fontFamily: "'Poppins',sans-serif",
  color:{xs:"white",md:"black"},display:"flex",alignItems:"center",
  ":hover":{
    color:"rgb(39,162,253,1)",
    textDecoration:"none",
    cursor:"pointer",
    
     
  }}}>
      Privacy Policy
  </TranslateText>
                  
                  {/* </CustomLink> */}
                {/* </CustomMenuItem> */}
              </Box>
              
              {/* <Divider  orientation='vertical' sx={{height:"10px",border:"1px solid #ddd",display:{xs:"none",md:"block"}}}/> */}

              <Box   sx={{bgcolor:{xs:"black",md:"transparent"},padding:"4px 12px", height:"26px",borderRadius:"10px",flexShrink:0}}>
                {/* <CustomMenuItem> */}
                  {/* <CustomLink to="/refund-policy" sx={{color:{xs:"white",md:"black"},display:"flex",alignItems:"center"}} > */}
                  {/* <TranslateText to="/refund-policy" component={Link} sx={{
  textDecoration:"none",
  fontSize:"12px",
  fontFamily: "'Poppins',sans-serif",
   color:{xs:"white",md:"black"},display:"flex",alignItems:"center",
  ":hover":{
    color:"rgb(39,162,253,1)",
    textDecoration:"none",
    cursor:"pointer",
   
     
  }}}> Returns Policy</TranslateText> */}
                   
                  {/* </CustomLink> */}
                {/* </CustomMenuItem> */}
              </Box>

              {/* <Divider  orientation='vertical' sx={{height:"10px",border:"1px solid #ddd",display:{xs:"none",md:"block"}}}/> */}

              <Box   sx={{bgcolor:{xs:"black",md:"transparent"},padding:"4px 12px", height:"26px",borderRadius:"10px",flexShrink:0}}>
                {/* <CustomMenuItem> */}
                  {/* <CustomLink to="/shipping-policy"  sx={{color:{xs:"white",md:"black"},display:"flex",alignItems:"center"}} > */}
                  {/* <TranslateText component={Link} to="/shipping-policy" sx={{
  textDecoration:"none",
  fontSize:"12px",
  fontFamily: "'Poppins',sans-serif",
  color:{xs:"white",md:"black"},display:"flex",alignItems:"center",
  ":hover":{
    color:"rgb(39,162,253,1)",
    textDecoration:"none",
    cursor:"pointer",
    
     
  }}}>  */}
                    {/* Shipping Policy</TranslateText> */}
                  {/* </CustomLink> */}
                {/* </CustomMenuItem> */}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={2}  >
          <Box  sx={{textAlign:{xs:"start",},alignItems:"center",justifyContent:{xs:"start",sm:"center"}}}>
            <TranslateText sx={[styles.headers,{fontSize:"20px",lineHeight:"44px"}]}>
              SOCIAL MEDIA
            </TranslateText>
            <Box sx={{display:"flex",gap:"10px"}}>

            <IconButton
              component="a"
              href="https://www.facebook.com/MAYIGlobalMovement"
              target="_blank"
              title="Facebook"
              sx={{padding:"0px"}}
            >
              <FacebookRounded  sx={{fontSize:"32px",padding:"0px",color:"#000"}} />
            </IconButton>
            <IconButton
              component={"a"}
              href="https://www.instagram.com/mayiglobalmovement/"
              target="_blank"
              title="Instagram"
              sx={{padding:"0px"}}
            >
              <Instagram  sx={{fontSize:"32px",padding:"0px",color:"#000"}} />
            </IconButton>
            <IconButton
              component={"a"}
              href="https://www.youtube.com/@MAYIGlobalMovement"
              target="_blank"
              title="Youtube"
              sx={{padding:"0px"}}
            >
              <YouTubeIcon  sx={{fontSize:"32px",padding:"0px",color:"#000"}} />
            </IconButton>
            <IconButton
              component={"a"}
              href="https://t.me/MAYIGlobalMovement"
              target="_blank"
              title="Telegram"
              sx={{padding:"0px"}}
            >
              <TelegramIcon  sx={{fontSize:"32px",padding:"0px",color:"#000"}} />
            </IconButton>
            <IconButton
              component={"a"}
              href=" https://www.linkedin.com/company/mayi-global-movement/"
              target="_blank"
              title="LinkedIn"
              sx={{padding:"0px"}}
            >
              <LinkedIn  sx={{fontSize:"32px",padding:"0px",color:"#000"}} />
            </IconButton>
            </Box>
          
          </Box>
          {/* <Grid item xs={12} sm={6} md={3} sx={{p:"12px",textAlign:"center",display:"flex",alignItems:{xs:"start",sm:"flex-end"},justifyContent:"end",flexDirection:"column"}}>
            <TranslateText   sx={[styles.headers,{mb:"21px",fontSize:"17.01px"}]}>
              PAYMENT METHODS
            </TranslateText>
            <Stack direction="row" sx={[styles.paymentIcons,{justifyContent:"center",alignItems:"center"}]}>
              <Box component="img" src={razorpay_img} sx={{height:"24px"}}/>
            </Stack>
          </Grid> */}
          </Grid>
        </Grid>
        {/* <Divider sx={{border:"0.25px solid #ddd"}}/> */}
        
      </Box>
      </Box>
      <Grid container  sx={{bgcolor:"#000",marginBottom:{xs:authtoken?"72px":"0px",md:"0px"}}}>
          <Grid item xs={12} sx={{display:{sm:"flex"},justifyContent:"center",gap:"4px"}}>
          <Box sx={{display:"flex",justifyContent:"center",gap:"2px",alignItems:"center"}}><Typography align="center" variant="subtitle1" sx={{ fontFamily: "'Poppins',sans-serif",textAlign:"center",color:"primary.contrastText",lineHeight:{xs:"20px", md:"44px"},fontSize:{xs:"9px",md:"14px"}}}>
            MAYI IQ AI TECHNOLOGIES LLP © Copyright {new Date().getFullYear()}.</Typography> <TranslateText align="center" variant="subtitle1" sx={{ fontFamily: "'Poppins',sans-serif",textAlign:"center",color:"primary.contrastText",lineHeight:{xs:"20px", md:"44px"},fontSize:{xs:"9px",md:"14px"}}}>All Rights Reserved. | 
            </TranslateText></Box><Box sx={{display:"flex",justifyContent:"center",gap:"2px",alignItems:"center"}}><TranslateText align="center" variant="subtitle1" sx={{ fontFamily: "'Poppins',sans-serif",textAlign:"center",color:"primary.contrastText",lineHeight:{xs:"20px", md:"44px"},fontSize:{xs:"9px",md:"14px"}}}>Intelligently Assisted by Intelligent</TranslateText><Box component={'img'} sx={{width: {sm:"12px",xs:"9px"} }} src={x} /></Box> 
          </Grid>
        </Grid>
     
    </Box>
  );
}

export default Footer;
